import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ModalComponent from "../../../../Components/Modal/ModalComponent";
import {
    ContainerStyled,
    MetricsRowStyled,
    MetricCardStyled,
    MetricValueStyled,
    MetricLabelStyled,
    PreviewContainerStyled,
    PreviewHeaderStyled,
    NotificationCardStyled,
    AvatarStyled,
    NotificationContentStyled,
    NotificationTitleRowStyled,
    NotificationTitleStyled,
    NotificationTimeStyled,
    NotificationBodyStyled,
    ActionsRowStyled,
    BackButtonStyled,
} from '../styled';
import DateUtil from "../../../../Utils/DateUtil";
import {Typography} from "@material-ui/core";

class ModalDetailsHistoryComponent extends Component {
    formatDate(rawDate) {
        if (!rawDate) return '-';
        try {
            return DateUtil.raw(rawDate).toDateTime24();
        } catch (e) {
            return rawDate;
        }
    }

    render() {
        const { isOpen, onClose, data } = this.props;

        if (!data) return null;

        const sentAt = this.formatDate(data.sent_at || data.created_at);
        const summary = data.summary || {};
        const ratings = summary.ratings || {};
        const push = summary.push || {};
        const totalRecipients = data.send_to_all
            ? 'Todos os clientes'
            : `${summary.total_recipients || 0} destinatário(s)`;

        return (
            <ModalComponent isOpen={isOpen} onClose={onClose} title={'Detalhes da Mensagem'} maxWidth={1024}>
                <ContainerStyled>
                    <div>
                        <Typography variant={'h6'} color={'primary'}>
                            {data.subject || 'Mensagem'}
                        </Typography>
                        <Typography variant={'caption'} color={'textSecondary'}>
                            {sentAt} · {totalRecipients}
                        </Typography>
                    </div>

                    {/* Bloco de Métricas */}
                    <MetricsRowStyled>
                        <MetricCardStyled>
                            <MetricValueStyled>{push.sent ?? summary.total_recipients ?? 0}</MetricValueStyled>
                            <MetricLabelStyled>enviadas</MetricLabelStyled>
                        </MetricCardStyled>

                        <MetricCardStyled>
                            <MetricValueStyled>
                                {summary.read_count ?? 0}
                                <span style={{ fontSize: '12px', fontWeight: 'normal', display: 'block' }}>
                                    ({summary.read_percent ?? 0}%)
                                </span>
                            </MetricValueStyled>
                            <MetricLabelStyled>lidas</MetricLabelStyled>
                        </MetricCardStyled>

                        <MetricCardStyled>
                            <MetricValueStyled>👍 {ratings.relevant ?? 0}</MetricValueStyled>
                            <MetricLabelStyled>Relevante</MetricLabelStyled>
                        </MetricCardStyled>

                        <MetricCardStyled>
                            <MetricValueStyled>😐 {ratings.irrelevant ?? 0}</MetricValueStyled>
                            <MetricLabelStyled>Irrelevante</MetricLabelStyled>
                        </MetricCardStyled>

                        <MetricCardStyled>
                            <MetricValueStyled>🚫 {ratings.not_interested ?? 0}</MetricValueStyled>
                            <MetricLabelStyled>Não interessa</MetricLabelStyled>
                        </MetricCardStyled>
                    </MetricsRowStyled>

                    {/* Prévia da Mensagem */}
                    <PreviewContainerStyled>
                        <PreviewHeaderStyled>
                            CONTEÚDO DA MENSAGEM
                        </PreviewHeaderStyled>

                        <NotificationCardStyled>
                            <AvatarStyled>M</AvatarStyled>
                            <NotificationContentStyled>
                                <NotificationTitleRowStyled>
                                    <NotificationTitleStyled>{data.subject}</NotificationTitleStyled>
                                    <NotificationTimeStyled>{sentAt}</NotificationTimeStyled>
                                </NotificationTitleRowStyled>
                                <NotificationBodyStyled>{data.body}</NotificationBodyStyled>
                            </NotificationContentStyled>
                        </NotificationCardStyled>
                    </PreviewContainerStyled>

                    {/* Botão de Ação */}
                    <ActionsRowStyled>
                        <BackButtonStyled type="button" onClick={onClose}>
                            VOLTAR
                        </BackButtonStyled>
                    </ActionsRowStyled>
                </ContainerStyled>
            </ModalComponent>
        );
    }
}

ModalDetailsHistoryComponent.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    data: PropTypes.object,
};

export default ModalDetailsHistoryComponent;
